export enum PropertyMatchOperator {
  HasResponse = 'has a response',
  HasNoResponse = 'has no response',
  IsAnyOf = 'is any of',
  IsNoneOf = 'is none of',
  Contains = 'contains',
  NotContain = "doesn't contain",
  IsExactly = 'is exactly',
  StartsWith = 'starts with',
  EndsWith = 'ends with',
  AnsweredCorrectly = 'answered correctly',
  AnsweredIncorrectly = 'answered incorrectly',
  NotAnswered = 'not answered',
}
